/**
 * Onboarding flow — shared types and dummy step data.
 *
 * Structural shell only: step content is placeholder copy. Follow-up specs
 * may swap the result of `getOnboardingSteps()` for real per-step content
 * without changing layout components.
 */

/** Total number of sequential onboarding steps. */
export const ONBOARDING_TOTAL_STEPS = 6;

/** Shape of a single onboarding step record. */
export interface StepData {
  /** 1-based step index, ranging from 1 to ONBOARDING_TOTAL_STEPS. */
  id: number;
  /** Question / prompt text shown on the left column. */
  question: string;
  /** Image URL shown on the right column (hidden on viewports < lg). */
  image: string;
}

/** Public contract for the navigation hook. */
export interface UseOnboardingNavigation {
  currentStep: number;
  totalSteps: number;
  next: () => void;
  prev: () => void;
  complete: () => void;
  setStep: (step: number) => void;
}

const STEP_IMAGES: Record<number, string> = {
  1: "https://storage.googleapis.com/carry_images/onboarding/onboarding-bag.webp",
  2: "https://storage.googleapis.com/carry_images/onboarding/onboarding-address.webp",
  3: "https://storage.googleapis.com/carry_images/onboarding/membership.webp",
  4: "https://storage.googleapis.com/carry_images/onboarding/calendar.webp",
  5: "https://storage.googleapis.com/carry_images/onboarding/expenses.webp",
  6: "https://storage.googleapis.com/carry_images/onboarding/register.webp",
};

/**
 * Returns the six placeholder onboarding steps.
 *
 * Dummy content only — real per-step copy, fields, and validation are
 * out of scope for this structural change.
 */
export const getOnboardingSteps = (): StepData[] =>
  Array.from({ length: ONBOARDING_TOTAL_STEPS }, (_, idx) => ({
    id: idx + 1,
    question: `Pregunta del paso ${idx + 1}`,
    image: STEP_IMAGES[idx + 1],
  }));
